import React from "react";
import Router from "next/router";

import {
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 375,
    padding: theme.spacing(1, 2, 1),
    marginTop: theme.spacing(5),
  },
  title: {
    fontStyle: "normal",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  address: {
    marginBottom: theme.spacing(2),
  },
}));

const AddressCard = () => {
  const classes = useStyles();

  const handleContactUs = () => {
    Router.push("/contact");
  };

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography
          className={classes.title}
          variant="h5"
          component="h2"
          gutterBottom
        >
          Trace America, LLC
        </Typography>
        <Typography component="address" className={classes.address}>
          <Typography variant="body2" component="span" display="block">
            P.O. Box 2267
          </Typography>
          <Typography
            variant="body2"
            component="span"
            display="block"
            gutterBottom
          >
            Bonita Springs, Florida 34133
          </Typography>
          <Typography
            variant="body2"
            component="span"
            display="block"
            gutterBottom
          >
            Tel: <a href="tel:800-827-1834">(800) 827-1834</a>
          </Typography>
        </Typography>
        <Typography
          variant="body2"
          component="span"
          display="block"
          gutterBottom
        >
          License Number A2100259
        </Typography>
      </CardContent>
      <CardActions>
        <Button onClick={handleContactUs} variant="text" color="primary">
          Contact Us
        </Button>
      </CardActions>
    </Card>
  );
};

export default AddressCard;
